exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".badge-new[data-v-76f5f338]{font-size:11px;font-weight:700;background-color:#e6f0fc;padding:2px 6px;border-radius:6px}.customer-service[data-v-76f5f338]{color:#0c568e}.redirection-btn[data-v-76f5f338]{background-color:#2dd4bf;border-color:#2dd4bf;color:#fff;font-size:14px;padding:6px 15px;border-radius:3px;margin-left:20px}.redirection-btn[data-v-76f5f338]:hover{background-color:#5eead4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-76f5f338","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/context/context.scss
// module id = vy5f
// module chunks = 2